import {toastr} from 'react-redux-toastr';
import * as types from './actionTypes';
import Resource from "../services/Resource";
import PrivateAPIResource from "../services/PrivateAPIResource";
import * as spinnerActions from './spinnerActions';
import * as userActions from './userActions';
import {toastrErrorHandler} from "./utils";

export function getCompany(companyId) {
    return function (dispatch) {
        return PrivateAPIResource.get('companies', companyId)
            .then((data)  => {
                dispatch(getCompanySuccess(data));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function getCompanySuccess(company) {
    return {type: types.GET_COMPANY_SUCCESS, company};
}

export function createCompanySuccess(company) {
    return {type: types.CREATE_COMPANY_SUCCESS, company};
}

export function updateCompanySuccess(company) {
    return {type: types.UPDATE_COMPANY_SUCCESS, company};
}

export function resetCompany() {
    return { type: types.RESET_COMPANY_PROFILE_STATE };
}

export function createCompany(data) {
    return function (dispatch) {
        return PrivateAPIResource.create('companies', data, true)
            .then(company  => {
                dispatch(createCompanySuccess(company));
            })
            .catch(toastrErrorHandler);
    }
}

export function updateCompanyVimeo(id, data) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update(`companies/${id}`, 'vimeo', data).then(company => {
            dispatch(updateCompanySuccess(company));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateCompany(id, data) {
    return function (dispatch) {
        return PrivateAPIResource.update('companies', id, data, true)
            .then(company  => {
                dispatch(updateCompanySuccess(company));
            })
            .catch(toastrErrorHandler);
    }
}

export function updateCompanySelectedMunicipaltyId(municipalityId) {
    return {type: types.UPDATE_SELECTED_MUNICIPALITY_ID, municipalityId};
}

export function updateCompanyAddressId(addressId) {
    return {type: types.UPDATE_SELECTED_ADDRESS_ID, addressId}
}

export function clearCompanyCityInformation() {
    return {type: types.CLEAR_CITY_INFORMATION}
}

export function loadCompanyArticleCategoriesSuccess(articleCategories) {
    return {type: types.LOAD_COMPANY_ARTICLES_CATEGORIES_SUCCESS, articleCategories}
}

export function loadCompanyArticleCategories(portalId) {
    return function (dispatch) {
        return PrivateAPIResource.all('companies/articles-categories', {portalId})
            .then(articleCategories => {
                dispatch(loadCompanyArticleCategoriesSuccess(articleCategories))
            })
    }
}

export function loadCompanyCategories(portalId) {
    return function (dispatch) {
        return PrivateAPIResource.all('company-categories', {portalId})
            .then((data)  => {
                dispatch(loadCompanyCategoriesSuccess(data));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function loadCompanyCategoriesSuccess(categories) {
    return {type: types.LOAD_COMPANY_CATEGORIES_SUCCESS, categories};
}

export function loadCompanyPortals() {
    return function (dispatch) {
        return PrivateAPIResource.all('company-portals')
            .then((data)  => {
                dispatch(loadCompanyPortalsSuccess(data));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function loadCompanyPortalsSuccess(portals) {
    return {type: types.LOAD_COMPANY_PORTALS_SUCCESS, portals};
}

export function loadCompanies(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.all(`companies?page=${page}`, sortParams)
            .then((data)  => {
                return dispatch(loadCompaniesSuccess(data));
            });
    }
}

export function loadCompanyKeywordsPacks(sortParams) {
    return function(dispatch) {
        return PrivateAPIResource.all('keywords-packs', sortParams).then(companyKeywordsPacks => {
            dispatch(loadCompanyKeywordsPacksSuccess(companyKeywordsPacks))
        }).catch(error => {
            throw error;
        });
    }
}

export function loadCompanyKeywordsPacksSuccess(companyKeywordsPacks) {
    return {type: types.LOAD_COMPANY_KEYWORDS_PACKS_SUCCESS, companyKeywordsPacks};
}

export function restoreCompany(id) {
    return function (dispatch) {
        return PrivateAPIResource.put(`companies/${id}/restore`)
            .then(data => {
                dispatch(updateCompanySuccess(data));
            });
    }
}

export function loadCompaniesSuccess(companies) {
    return {type: types.LOAD_COMPANIES_SUCCESS, companies};
}

/**
 * Set users to company
 *
 * @param {int} companyId
 * @param {array} userIds
 *
 **/
export function addMembers(companyId, userIds) {
    return function (dispatch, getState) {
        dispatch(spinnerActions.showSpinner());
        return PrivateAPIResource.put(`companies/${companyId}/users/${userIds.join(',')}`)
            .then((data)  => {
                toastr.success('Virksomhed ændret sig.');
                dispatch(spinnerActions.hideSpinner());
            })
            .then(() => {
                if(userIds.indexOf(getState().user.id) !== -1) {
                    dispatch(userActions.getCurrentUser());
                }
            })
            .catch(err => {
                dispatch(spinnerActions.hideSpinner());
                throw  err;
            });
    }
}

/**
 * Change categories count in company
 *
 * @param {int} companyId
 * @param {array} categoryIds
 *
 **/
export function changeCompanyCategories(companyId, categoryIds) {
    return function (dispatch) {
        dispatch(spinnerActions.addSpinnerButton('company-category-change-submit'));
        return PrivateAPIResource.put(`companies/${companyId}/categories/${categoryIds.join(',')}`)
            .then((data)  => {
                dispatch(spinnerActions.removeSpinnerButton('company-category-change-submit'));
            })
            .catch(err => {
                dispatch(spinnerActions.removeSpinnerButton('company-category-change-submit'));
                throw  err;
            });
    }
}


export function showCompanyCategoryRestrictionModal(companyId, categories, count) {
    return {type: types.SHOW_COMPANY_CATEGORY_RESTRICTION_MODAL, companyId, categories, count};
}

export function hideCompanyCategoryRestrictionModal() {
    return {type: types.HIDE_COMPANY_CATEGORY_RESTRICTION_MODAL};
}

export function deleteCompany(id) {
    return dispatch => PrivateAPIResource.remove('companies', id).then(() => {
        dispatch({ type: types.DELETE_COMPANY_SUCCESS, companyId: id });
    });
}


// WEBPACK FOOTER //
// ./web/src/actions/companyActions.js